'use strict';

const _each = require('lodash/each');
const appendParamToURL = require('./appendParamToURL');

/**
 * @function
 * @description appends the parameters to the given url and returns the changed url
 * @param {String} url the url to which the parameters will be added
 * @param {Object} params
 */
const appendParamsToUrl = (url, params) => {
    let _url = url;
    _each(params, function (value, name) {
        _url = appendParamToURL(_url, name, value);
    }.bind(this));
    return _url;
};

module.exports = appendParamsToUrl;
